import { cloneDeep, has, omit, set } from 'lodash';

import generateClientUuid from 'sharedParts/utils/generateClientUuid';

const cloneBlock = block => {
  const clonedBlock = cloneDeep(block);
  clonedBlock.clientUuid = generateClientUuid();

  // setting new id for options @sinslav
  if (has(block, 'options')) {
    set(
      clonedBlock,
      'options',
      block.options.map(option => ({
        ...option,
        id: generateClientUuid(),
      })),
    );
  }

  return omit(clonedBlock, 'id');
};

export default cloneBlock;
